import React from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import { transformChartData } from "../../../utils/chartUtils";

const LineChart = ({ data, selectedMetrics, title = false, type }) => {
  const [chartData, labels] = transformChartData({
    apiData: data,
    selectedMetrics,
  });

  const datasets = chartData.map((dataItem) => ({
    ...dataItem,
    tension: 0.4,
  }));

  return (
    <div
      style={{
        width: "100%",
        height: "200px",
        minHeight: "150px",
      }}
    >
      <Line
        style={{ marginTop: 15 }}
        data={{
          datasets,
          labels,
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            title: {
              display: !!title,
              text: title,
            },
            tooltip: {
              titleFont: {
                size: 14,
                family: "DM Sans",
              },
              bodyFont: {
                size: 12,
                family: "DM Sans",
              },
              callbacks: {
                label: function (context) {
                  const value = context.parsed.y;
                  if (type === "revenue") {
                    return `$${(value / 100).toFixed(2)}`;
                  }
                  return value;
                },
              },
            },
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                callback: function (value, index, ticks) {
                  return type == "revenue"
                    ? `$${(value / 100).toFixed(2)}`
                    : value;
                },
                font: {
                  size: 12,
                  weight: "400",
                  family: "Poppins",
                },
                color: "#565556",
              },
            },
            x: {
              grid: {
                display: false,
              },
              ticks: {
                callback: function (value, index, values) {
                  const xLabel = this.getLabelForValue(value);
                  if (typeof xLabel === "string") {
                    return xLabel.slice(0, 3);
                  }
                  return xLabel;
                },
                font: {
                  size: 12,
                  weight: "400",
                  family: "Poppins",
                },
                color: "#565556",
              },
            },
          },
        }}
      />
    </div>
  );
};

export default LineChart;
